<template>
    <div class="assignment-edit">
        <design-2021-assignment-edit-title-buttons-component
            v-if="assignment"
            :assignment-in="assignment"
            :group-in="groupIn"
            :can-edit-portfolio="canEditPortfolio"
            :portfolio-in="portfolioIn"
            @setup-continent="setupContinent">
        </design-2021-assignment-edit-title-buttons-component>

        <design-2021-portfolio-edit-update-category-modal-component
            :category="portfolioIn.categories[0]"
            :group-id="groupIn.id"
            :portfolio-in="portfolioIn">
        </design-2021-portfolio-edit-update-category-modal-component>

        <div class="assignment-edit-content">
            <div
                class="row"
                v-if="assignment">
                <div class="col-12 col-md-4 col-xl-3 assignment-edit-sidebar-menu">
                    <design-2021-assignment-edit-sub-assignments-nav-component
                        :group-id-in="groupIn.id"
                        :can-edit-portfolio="canEditPortfolio"
                        :assignment-in="assignment"
                        @selected-sub-assignment="changeSelectedSubAssignment($event)">
                    </design-2021-assignment-edit-sub-assignments-nav-component>
                </div>

                <div
                    class="col-12 col-md-8 col-xl-9"
                    v-if="selectedSubAssignment">
                    <design-2021-assignment-edit-sub-assignment-component
                        :profile-categories-in="profileCategoriesIn"
                        :assignment-in="assignment"
                        :sub-assignment-in="selectedSubAssignment"
                        :can-edit-portfolio="canEditPortfolio"
                        :group-in="groupIn">
                    </design-2021-assignment-edit-sub-assignment-component>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { ords } from '../../../app';
import { Common as common } from '../../../helpers/common';
import Design2021PortfolioEditUpdateCategoryModalComponent from '../../portfolio/edit/modals/design-2021-portfolio-edit-update-category-modal-component.vue';

const assignmentOrds = ords.use('assignment');

export default {
    name: 'design-2021-assignment-edit-component',
    components: { Design2021PortfolioEditUpdateCategoryModalComponent },
    props: {
        assignmentIn: {
            type: Object,
            required: true,
        },
        portfolioIn: {
            type: Object,
            required: false,
        },
        groupIn: {
            type: Object,
            required: false,
        },
        profileCategoriesIn: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            selectedSubAssignmentId: null,
            assignment: null,
            subscription: null,
            feedback: this.assignmentIn.feedback ? this.assignmentIn.feedback : [],
        };
    },
    methods: {
        changeSelectedSubAssignment(id) {
            this.selectedSubAssignmentId = id;
        },

        setupContinent() {
            this.$bvModal.show('update-portfolio-category-modal-' + this.portfolioIn.categories[0].id);
        },
    },
    computed: {
        common() {
            return common;
        },
        canEditPortfolio() {
            if (this.groupIn) {
                return this.groupIn.permissions.can_edit_portfolio;
            }
            return true;
        },
        selectedSubAssignment() {
            for (const subAssignment of this.assignment.sub_assignments) {
                if (subAssignment.id === this.selectedSubAssignmentId) {
                    return subAssignment;
                }
            }
            return null;
        },
    },
    mounted() {
        assignmentOrds.add(this.assignmentIn);
        this.subscription = assignmentOrds
            .with(['deadlines', 'publishings', 'portfolio_rating', 'assignment_cooperations'])
            .with('sub_assignments', (callback) => {
                callback
                    .orderBy('order')
                    .with(['deadlines', 'portfolio_rating', 'assignment_cooperations'])
                    .with('pages', (pagesCallback) => {
                        pagesCallback.orderBy('order');
                        pagesCallback.with('parts', (partsCallback) => {
                            partsCallback.orderBy('order');
                            partsCallback.with(['text', 'video_link', 'part_files', 'list_items', 'list_options']);

                            //todo temp relation until ords update
                            partsCallback.with('page', (npCallback) => {
                                npCallback.with('sub_assignment', (saCallback) => {
                                    saCallback.with('pages', (nestedPagesCallback) => {
                                        nestedPagesCallback.orderBy('order');
                                        nestedPagesCallback.with('parts');
                                    });
                                });
                            });
                        });
                    });
            })
            .find(this.assignmentIn.id)
            .subscribe((assignment) => {
                this.assignment = assignment;
            });
    },
    beforeDestroy() {
        this.subscription.unsubscribe();
    },
};
</script>

<style scoped>
.sub-assignment-drag-handle {
    color: lightgray;
    margin-right: 15px;
}

.sub-assignment-drag-handle:hover {
    color: black;
}

.list-group-item {
    border: none;
    font-size: 0.875rem;
}

.list-group-item:hover,
.list-group-item.active {
    background-color: #e8eff4bf;
    color: #212529;
}

.edit-assignments .header {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    margin-bottom: 21px;
    flex-direction: column;
}

.edit-assignments .header >>> .actions {
    align-self: flex-end;
}

.sub-assignments-edit-nav {
    margin-bottom: 60px;
}

@media (min-width: 768px) {
    .sub-assignments-edit-nav {
        margin-bottom: 0px;
    }

    .edit-assignments .header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 21px;
        flex-direction: row;
    }

    .edit-assignments .header >>> .actions {
        align-self: baseline;
    }
}
</style>
